export function reloadTaskpane(): void {
  window.location.reload();
}
